module.exports = __webpack_public_path__ + "images/gow_rgba(0,0,0,0.7).jpg?v=ec1c1fdf174a73b44090aab765cb34ac";